import { render, staticRenderFns } from "./MemberReview.vue?vue&type=template&id=06c625e5"
import script from "./MemberReview.vue?vue&type=script&lang=js"
export * from "./MemberReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports